module.exports = __webpack_public_path__ + "assets/img/f05b-nz.svg";